import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { IonIcon, IonItem, IonLabel, IonTextarea } from "@ionic/vue";
import { useField } from "vee-validate";

import { BaseTextareaProps } from "@/types/props";
import { TextareaBaseEmits } from "@/types/emits";

import { closeCircleOutline } from "ionicons/icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'TextareaBase',
  props: {
    autoGrow: { type: Boolean },
    modelValue: {},
    autocapitalize: {},
    autofocus: { type: Boolean },
    clearOnEdit: { type: Boolean },
    color: {},
    textareaClass: {},
    cols: {},
    debounce: {},
    disabled: { type: Boolean },
    enterkeyhint: {},
    inputmode: {},
    maxlength: {},
    minlength: {},
    mode: {},
    name: {},
    placeholder: {},
    readonly: { type: Boolean },
    required: { type: Boolean },
    rows: { default: 4 },
    spellcheck: { type: Boolean },
    wrap: {},
    validateOption: {}
  },
  emits: ["change", "blur", "focus", "update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// Vee-Validate Composable
const {
    name,
    value,
    errors,
    handleChange,
    handleBlur,
    resetField,
    validate
} = useField(
    props.validateOption?.name ?? '',
    props.validateOption?.rules ?? '',
    {
        valueProp: props.modelValue,
        initialValue: JSON.parse(JSON.stringify(props.modelValue ?? '')),
        label: props.validateOption?.label ?? props.validateOption?.name,
        ...props.validateOption?.options ?? {}
    }
)

window.addEventListener('change-language', () => validate({ mode: 'force' }))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), {
    lines: "none",
    class: "custom-textarea"
  }, {
    default: _withCtx(() => [
      (_ctx.$slots.default)
        ? (_openBlock(), _createBlock(_unref(IonLabel), {
            key: 0,
            class: "fixed-label-width"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createTextVNode(_toDisplayString(_unref(name)), 1)
              ])
            ]),
            _: 3
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonTextarea), {
        value: __props.modelValue,
        label: "",
        "auto-grow": props.autoGrow,
        autocapitalize: props.autocapitalize,
        autofocus: props.autofocus,
        "clear-on-edit": props.clearOnEdit,
        color: props.color,
        class: _normalizeClass(__props.textareaClass),
        cols: props.cols,
        debounce: props.debounce,
        disabled: props.disabled,
        enterkeyhint: props.enterkeyhint,
        inputmode: props.inputmode,
        maxlength: props.maxlength,
        minlength: props.minlength,
        mode: props.mode,
        name: props.name,
        placeholder: props.placeholder,
        readonly: props.readonly,
        required: props.required,
        rows: props.rows,
        spellcheck: props.spellcheck,
        wrap: props.wrap,
        onIonInput: _cache[0] || (_cache[0] = ($event: any) => {emit('update:modelValue', $event.detail.value); _unref(handleChange)($event);}),
        onIonBlur: _cache[1] || (_cache[1] = ($event: any) => {_unref(handleBlur)($event); emit('blur', $event)}),
        onIonChange: _cache[2] || (_cache[2] = ($event: any) => (emit('change', $event))),
        onIonFocus: _cache[3] || (_cache[3] = ($event: any) => (emit('focus', $event)))
      }, null, 8, ["value", "auto-grow", "autocapitalize", "autofocus", "clear-on-edit", "color", "class", "cols", "debounce", "disabled", "enterkeyhint", "inputmode", "maxlength", "minlength", "mode", "name", "placeholder", "readonly", "required", "rows", "spellcheck", "wrap"]),
      (__props.validateOption?.options && __props.validateOption.options.reset)
        ? (_openBlock(), _createBlock(_unref(IonIcon), {
            key: 1,
            slot: "end",
            icon: _unref(closeCircleOutline),
            onClick: _cache[4] || (_cache[4] = ($event: any) => {_unref(resetField)(); _ctx.$emit('update:modelValue', _unref(value))})
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonLabel), {
        slot: "error",
        class: "base-input-error"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors), (error) => {
            return (_openBlock(), _createElementBlock("span", { key: error }, _toDisplayString(error), 1))
          }), 128))
        ]),
        _: 1
      }),
      (_ctx.$slots['helper'])
        ? (_openBlock(), _createBlock(_unref(IonLabel), {
            key: 2,
            slot: "helper"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "helper")
            ]),
            _: 3
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})